import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@blueprintjs/core';
import { ProcessMenuActionsType } from 'routes/ProcessOptions/ProcessOptions.types';

interface Props {
  disabled: boolean;
  context: {
    onActionMenuItemClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    props: {
      showActionMenuItem: boolean,
      hasPrivilegeToCreateNew: boolean;
      hasPrivilegeToDelete: boolean;
      hasPrivilegetoView: boolean;
    }
  };
}

const DialedDigitExtractionServerGridActionMenu: FunctionComponent<Props> = ({
  disabled,
  context: {
    onActionMenuItemClick,
    props: {
      showActionMenuItem,
      hasPrivilegetoView,
      hasPrivilegeToCreateNew,
      hasPrivilegeToDelete,
    },
  },
}: Props) => {
  const { t } = useTranslation();

  return (
    <Menu>
      {hasPrivilegetoView && showActionMenuItem && (
        <MenuItem
          id={ProcessMenuActionsType.View}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('ss8Distributors.grid.view')}
        />
      )}
      {hasPrivilegeToCreateNew && showActionMenuItem && (
        <MenuItem
          id={ProcessMenuActionsType.Edit}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('ss8Distributors.grid.edit')}
        />
      )}
      {hasPrivilegeToDelete && showActionMenuItem && (
        <MenuItem
          id={ProcessMenuActionsType.Delete}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('ss8Distributors.grid.delete')}
        />
      )}
    </Menu>
  );
};

export default DialedDigitExtractionServerGridActionMenu;
